var $9dd2209c22b301e2$exports = {};
$9dd2209c22b301e2$exports = {
    "collectionLabel": `Suggestions`
};


export {$9dd2209c22b301e2$exports as default};
//# sourceMappingURL=en-US.mjs.map
